<template>
  <div
    class="rounded-3xl py-1.5 pl-3.5 pr-1.5 flex flex-wrap items-center gap-x-2 gap-y-1.5 min-h-[36px]"
    :class="[
      analysis.state === 'done' ? 'bg-secondary-lightest ring-1 ring-secondary' : 'bg-gray-light',
      {'cursor-pointer': !!card.membership}
    ]"
    @click="card.membership && $emit('manage', card)"
  >
    <span class="text-sm font-bold truncate max-w-[110px] shrink-0">{{ analysis.shortName }}</span>

    <template v-if="analysis.state === 'inactive'">
      <span class="flex-1 min-w-0 text-xs text-gray-500 line-clamp-2">{{ analysis.hint }}</span>
      <button
        class="shrink-0 bg-primary text-white text-sm font-semibold rounded-full px-3.5 py-1.5"
        @click.stop="$emit('activate', card)"
      >
        Activer
      </button>
    </template>

    <template v-else>
      <div class="flex-1 min-w-[80px] flex flex-col gap-0.5 py-0.5">
        <div class="flex items-center gap-2">
          <div class="flex-1 min-w-[20px] h-[5px] rounded-full bg-white overflow-hidden">
            <div
              class="h-full rounded-full"
              :class="analysis.state === 'done' ? 'bg-secondary-darkest' : 'bg-primary'"
              :style="{width: `${analysis.percent}%`}"
            />
          </div>
          <span
            v-if="analysis.fillLabel"
            class="text-sm font-bold whitespace-nowrap"
            :class="analysis.state === 'done' ? 'text-secondary-darkest' : 'text-primary'"
          >
            {{ analysis.fillLabel }}
          </span>
        </div>
        <span
          v-if="analysis.state === 'done' || analysis.advance"
          class="text-xs line-clamp-1"
          :class="analysis.state === 'done' ? 'text-secondary-darkest font-semibold' : 'text-gray-500'"
        >
          {{ analysis.hint }}
        </span>
      </div>
      <!-- "Gérer" is always reachable; the reward button is a shortcut to
           the attribution, not a replacement for it. -->
      <div class="ml-auto shrink-0 flex items-center gap-1">
        <button
          v-if="analysis.canOffer"
          class="shrink-0 flex items-center gap-1 text-primary-dark text-sm font-bold rounded-full px-3.5 py-1.5"
          :style="{background: `linear-gradient(135deg, ${colors.secondary.DEFAULT}, ${colors.green.DEFAULT})`}"
          @click.stop="$emit('reward', card)"
        >
          <Gift :size="12" />
          {{ analysis.rewardLabel }}
        </button>
        <button
          class="shrink-0 border border-primary text-primary text-sm font-semibold rounded-full px-3.5 py-1.5 bg-white"
          @click.stop="$emit('manage', card)"
        >
          Gérer
        </button>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import {Gift} from "@lucide/vue";
import {colors} from "@/theme/colors";
import {DetectionLoyaltyCard} from "@/notification/interfaces";
import {DetectionCardAnalysis} from "@/notification/components/notification-detection/loyalty-cards/detectionCardAnalysis";

defineProps<{
    card: DetectionLoyaltyCard;
    /** Computed once by the parent and shared with the ring strip. */
    analysis: DetectionCardAnalysis;
}>();

defineEmits<{
    activate: [card: DetectionLoyaltyCard];
    manage: [card: DetectionLoyaltyCard];
    reward: [card: DetectionLoyaltyCard];
}>();
</script>
